/**
 * @generated SignedSource<<8cb75c7b3b73ab9a2e472588ffa9d560>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomEditMain_room$data = {
  readonly capacity: number | null;
  readonly description: string | null;
  readonly descriptionText: {
    readonly " $fragmentSpreads": FragmentRefs<"EditorJsField_text" | "useEditorJsField_text">;
  } | null;
  readonly id: string;
  readonly name: {
    readonly " $fragmentSpreads": FragmentRefs<"useTranslatableField_text">;
  } | null;
  readonly properties: ReadonlyArray<{
    readonly etgKey: string | null;
    readonly icon: string | null;
    readonly id: string;
    readonly name: string | null;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"RoomEditMainGeneral_room">;
  readonly " $fragmentType": "RoomEditMain_room";
};
export type RoomEditMain_room$key = {
  readonly " $data"?: RoomEditMain_room$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomEditMain_room">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomEditMain_room",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "capacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoomProperty",
      "kind": "LinkedField",
      "name": "properties",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "icon",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "etgKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Text",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useTranslatableField_text"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Text",
      "kind": "LinkedField",
      "name": "descriptionText",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EditorJsField_text"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useEditorJsField_text"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomEditMainGeneral_room"
    }
  ],
  "type": "Room",
  "abstractKey": null
};
})();

(node as any).hash = "341633bd62a89737fe6d1391411afa17";

export default node;
